import { createContext } from 'react';

export type DriverOptions = {
  seePriceWithCommission: boolean;
  isSubjectToVAT: boolean;
};

export type DriverOptionsContext = {
  isReady: boolean;
  driverOptions: DriverOptions;
};

export const driverOptionsContext = createContext<DriverOptionsContext>(undefined as unknown as DriverOptionsContext);
